import React from "react";
import { Label, InputText, Dropdown } from "../../../components/Inputs";

const DEFAULT_BODY = { title: "", url: "", type: "intern" };

const LinkForm = React.forwardRef(function LinkForm(
  { className = "", model = { body: JSON.stringify(DEFAULT_BODY) }, disabled },
  ref,
) {
  const [state, setState] = React.useState(() => {
    let parsed = {};
    try {
      parsed = JSON.parse((model || {}).body || "");
    } catch (error) {
      parsed = DEFAULT_BODY;
    }
    return {
      title: parsed.title || "",
      url: parsed.url || "",
      type: parsed.type || "intern",
      error: {
        title: null,
        url: null,
      },
    };
  });

  const validate = () => {
    const { error, ...model } = state;
    // check if all values are set
    const newError = { ...error };
    let isValid = true;
    Object.keys(model).forEach((key) => {
      if (newError[key] !== undefined && model[key] === "") {
        newError[key] = true;
        isValid = false;
      }
    });
    setState((prev) => ({ ...prev, error: newError }));
    if (!isValid) {
      return null;
    }
    return { body: JSON.stringify(model) };
  };

  React.useImperativeHandle(ref, () => ({
    getModel: () => validate(),
  }));

  const { title, url, type, error } = state;
  const TypeOptions = [
    { label: "Intern", value: "intern" },
    { label: "Extern", value: "extern" },
  ];
  return (
    <div className={className}>
      <div className="neg-margin-lr w3-row">
        <div
          className={`w3-col s4 pad-lr pad-top form-group-item ${
            error.title ? " error-group" : ""
          }`}
        >
          <Label htmlFor="title">{`Titel*`}</Label>
          <InputText
            id="titleId"
            className="w3-block w3-border"
            value={title}
            onChange={(event) => {
              const value = event.target.value;
              setState((prev) => ({ ...prev, title: value }));
            }}
            disabled={disabled}
          />
        </div>
        <div
          className={`w3-col s4 pad-lr pad-top form-group-item ${
            error.url ? " error-group" : ""
          }`}
        >
          <Label htmlFor="url">{`URL`}</Label>
          <InputText
            id="url"
            className="w3-block w3-border"
            value={url || ""}
            onChange={(event) => {
              const value = event.target.value;
              setState((prev) => ({ ...prev, url: value }));
            }}
            disabled={disabled}
          />
        </div>
        <div
          className={`w3-col s4 pad-lr pad-top form-group-item ${
            error.type ? " error-group" : ""
          }`}
        >
          <Label htmlFor="type">{`Intern/Extern*`}</Label>
          <Dropdown
            id="type"
            className="w3-block w3-border"
            value={type}
            options={TypeOptions}
            onChange={(event) => {
              const value = event.value;
              setState((prev) => ({ ...prev, type: value }));
            }}
            showClear
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
});

export default LinkForm;
